<template>
    <div style="height:100%;position:relative">
        <grid-view style="padding:0 24px;background:#fff;position:relative;height:100%">
            <template #tab>
                <a-tabs
                    :activeKey="selectedType"
                    @change="callback"
                    style="margin-top:20px"
                >
                    <a-tab-pane
                        :tab="item.title"
                        v-for="item in typeList"
                        :key="item.value"
                    >
                    </a-tab-pane>
                </a-tabs>
            </template>
            <template #grid>
                <grid-empty
                    :imgSrc="require('@/assets/nopost.svg')"
                    :loading="grid.loading"
                    v-if="(!grid.data) || (grid.data.length === 0)"
                    text="暂无帖子"
                    style="height:100%"
                ></grid-empty>
                <flex-col
                    v-else
                    style="position:relative;margin-bottom:78px"
                >
                    <flex-fill
                        v-for="v in grid.data"
                        :key="v.id"
                        style="border-bottom: 1px solid #E8ECF1"
                    >
                        <div>
                            <h4
                                class="title"
                                :title="v.title"
                            >
                                <a @click="toDetail(v)">

                                    <span v-if="v.status === '0'">
                                        [草稿]
                                    </span>

                                    <span v-if="v.status === '2'">
                                        [待审核]
                                    </span>
                                    
                                    <span v-if="v.status === '9'">
                                        [未通过]
                                    </span>
                                    <span v-if="v.title && v.title.trim()">{{ v.title }}</span>

                                    <span
                                        v-else
                                        style="opacity: 0.6;"
                                    >（无标题）</span>
                                </a>

                            </h4>
                        </div>
                        <div class="desc">

                            <span
                                class="type-info training-type"
                                v-if="v.isTrainArticle"
                            >培训园地</span>
                            <span
                                class="type-info share-type"
                                v-if="v.isShareArticle"
                            >技术分享</span>
                            <span
                                class="type-info question-type"
                                v-if="v.isQuestion"
                            >问答</span>
                            <span
                                v-if="selectedType === '1' && v.replyCount !== 0"
                                class="desc-item"
                            >
                                <eco-icon
                                    name="time"
                                    :size="14"
                                    class="desc-icon"
                                ></eco-icon>
                                {{ v.discussName }}
                                <span>
                                    <span>回复于</span>
                                    <date-to-string :date="v.replyDate" />
                                </span>
                            </span>
                            <span v-else>
                                <eco-icon
                                    name="answer"
                                    :size="14"
                                    class="desc-icon"
                                    style="margin-right:4px"
                                ></eco-icon>
                                <span
                                    v-if="v.replyCount === 0 && selectedType === '1'"
                                    class="desc-item user"
                                    style="margin-right:4px; "
                                > {{ v.author.nickname }}</span>
                                <span class="desc-item">
                                    <span style="color: #909399 !important">创建于
                                        <date-to-string
                                            :date="v.publishDate"
                                            style="
                        margin-right: 0;
                      "
                                        />
                                    </span>
                                </span>
                            </span>
                            <span class="desc-item">
                                <eco-icon
                                    name="see"
                                    :size="14"
                                    class="desc-icon"
                                ></eco-icon>
                                {{ v.viewCount }}
                            </span>
                            <span class="desc-item">
                                <eco-icon
                                    name="ask"
                                    :size="14"
                                    class="desc-icon"
                                ></eco-icon>
                                {{ v.replyCount }}
                            </span>
                            <span
                                v-if="v.isSolve && v.isQuestion"
                                class="desc-item"
                            >
                                <eco-icon
                                    name="checkmark1"
                                    :size="14"
                                    class="desc-icon"
                                ></eco-icon>
                                已解决
                            </span>
                        </div>
                    </flex-fill>

                </flex-col>

            </template>
            <template #extra>
                <div
                    style="padding:24px 0 24px 0;overflow:hidden;position:absolute;right:24px;bottom:0;margin-top:24px"
                    v-if="grid.page.total>grid.page.pageSize"
                >
                    <div
                        class="cntr pager"
                        style="overflow:hidden;"
                    >
                        <a-pagination
                            style="float:right"
                            v-bind="grid.page.toGrid()"
                            :item-render="itemRender"
                            @change="(page, pageSize)=>handleGrid({current:page, pageSize})"
                        ></a-pagination>
                    </div>
                </div>
            </template>
        </grid-view>
    </div>
</template>

<script>
import GridEmpty from "@/components/Empty.vue";
import DateToString from "@/views/post/component/DateToString.vue";
import { model, router } from "eco-cli";
import { getQuestionList } from "@/request/question.js";
const { Filter, Page, Sort } = model;
export default {
    data() {
        return {
            typeList: [
                {
                    title: "我发布的帖子",
                    value: "0"
                },
                {
                    title: "我回复的帖子",
                    value: "1"
                }
            ],
            selectedType: "0",
            grid: {
                loading: true,
                filter: Filter.new(),
                data: [],
                sort: null,
                page: Page.new({
                    pageSize: 5
                })
            }
        };
    },
    components: {
        GridEmpty,
        DateToString
    },
    mounted() {
        this.grid.filter.set("dataType", this.selectedType);
        this.updateGrid(true);
    },
    methods: {
        updateGrid(resetPage = false) {
            this.grid.loading = true;
            return getQuestionList({
                page: resetPage
                    ? Page.new({
                          pageSize: 5
                      })
                    : this.grid.page,
                filter: this.grid.filter
            })
                .then(({ list, page }) => {
                    // this.grid.data = list.map(v =>
                    //     Object.assign(v, { key: v.sid })
                    // );
                    this.grid.data = list;
                    this.grid.page = page;
                    // if(this.$refs.cntr)this.$refs.cntr.$el.scrollTop = 0
                })
                .finally(() => {
                    this.grid.loading = false;
                });
        },
        handleGrid(pagination, filters, sorter) {
            this.grid.page.current = pagination.current;
            this.updateGrid();
        },
        callback(key) {
            this.selectedType = key;
            this.grid.filter.set("dataType", this.selectedType);
            this.updateGrid(true);
        },
        toDetail(v) {
            if (v.isQuestion) router.open.forum("/question/" + v.id);
            if (v.isTrainArticle) router.open.forum("/training/" + v.id);
            if (v.isShareArticle) router.open.forum("/post/" + v.id);
        },
        itemRender(current, type, originalElement) {
            if (type === "prev") {
                return <a style="margin-right:8px"> 上一页 </a>;
            } else if (type === "next") {
                return <a style="margin-left:8px"> 下一页 </a>;
            }
            return originalElement;
        }
    }
};
</script>

<style lang="scss" scoped>
.title {
    @include line-ellipsis(2);
    max-width: 912px;
    word-break: break-all;
    margin-bottom: 10px;
    margin-top: 20px;
    font-weight: $font-weight-lg;
}

.title a:hover {
    color: $link-hover-color !important;
}

.desc {
    line-height: 22px;
    margin-bottom: 22px;

    .type-info {
        background: #777;
        color: #000;
        font-size: 14px;
        line-height: 24px;
        padding: 0 4px;
        margin-right: 4px;
        border-radius: 4px;
        display: inline-block;
    }

    .training-type {
        background: #f0fce3;
        color: #45bd09;
    }
    .share-type {
        background: #fff7e6;
        color: #fa8b0c;
    }
    .question-type {
        background: #f0f6ff;
        color: #4771f8;
    }

    span {
        font-size: 14px;
        color: $color-gray-light-4;
    }

    .desc-icon {
        margin-right: 2px;
    }
}

.desc-item {
    margin-right: 28px;
}

::v-deep .grid_page .search {
    margin-bottom: 0;
}

::v-deep .ant-tabs-tab {
    line-height: 22px !important;
}

::v-deep .ant-tabs-bar .ant-tabs-nav {
    height: 40px !important;
}

::v-deep .ant-tabs-bar .ant-tabs-nav .ant-tabs-tab {
    height: 40px !important;
    margin-right: 60px !important;
    color: #777;
}

::v-deep .ant-tabs-bar .ant-tabs-nav .ant-tabs-tab-active {
    color: #222 !important;
}

::v-deep .ant-tabs-bar {
    border-bottom: 1px solid #e8ecf1;
    margin-bottom: 0 !important;
}

.pager ::v-deep .ant-pagination-item-active {
    background: $color-primary !important;

    a {
        color: #fff;
    }
}

::v-deep .ant-pagination-item {
    border-color: transparent;
}
</style>
